import apiClient from "./apiClient";
import { Cript } from "../utils/cript";
import {
  AuthRequest,
  AuthResponse,
  VerifyTokenRequest,
  VerifyTokenResponse,
  LogoutRequest,
  LogoutResponse,
  DisassociaTSIDRequest,
  RecoverPasswordRequest,
  RecoverPasswordResponse,
  RecoverPasswordCheckRequest,
  RecoverPasswordCheckResponse,
} from "./Models/AuthModel";
import { AxiosResponse } from "axios";

export const login = async (
  username: string | null,
  password: string | null,
  ipCode?: number,
  key?: string | null,
  autoLogon?: boolean | null
): Promise<AuthResponse> => {
  let ip_Code = 0;
  // let key: string | null = null;
  let salt: string | null = null;
  let digest: string | null = null;
  if (key) {
    ip_Code = ipCode!;
    salt = Cript.getSalt().toLowerCase();
    var appKey: string | null =
      Cript.trim(username!).toLowerCase() + Cript.trim(password!).toLowerCase();
    appKey = Cript.sha1EsaDigest(appKey, appKey.length);
    appKey += salt;
    digest = Cript.sha1EsaDigest(appKey!, appKey!.length);
  } else {
    if (ipCode && ipCode === -1) {
      const baseUrl = `${window.location.protocol}//${window.location.host}`;
      const redirectUrl = `${baseUrl}/TSID_Redirect`;
      key = baseUrl; // Target url dopo l'autenticazione
      username = redirectUrl; // Redirect url per autenticazione
      password = null;
      digest = null;
      salt = null;
      ip_Code = -1;
    } else {
      if (ipCode && ipCode === -2) {
        key = password; // Target url dopo l'autenticazione
        password = null;
        digest = null;
        salt = null;
        ip_Code = -2;
      } else {
        ip_Code = 0;
        salt = Cript.getSalt().toLowerCase();
        if (autoLogon && password === null) {
          digest = "";
          key = null;
        } else {
          key =
            Cript.trim(username!).toLowerCase() +
            Cript.trim(password!).toLowerCase();
          key = Cript.sha1EsaDigest(key, key.length);
          var fullKey = key + salt;
          key = "";
          digest = Cript.sha1EsaDigest(fullKey, fullKey.length);
        }
      }
    }
  }
  const requestData: AuthRequest = {
    IpCode: ip_Code, // Chiave univoca
    Key: key, // Chiave da Teamsystem
    Username: username,
    Salt: salt,
    Digest: digest,
  };

  try {
    const response: AxiosResponse<AuthResponse> = await apiClient({
      method: "post",
      url: "/Authentication/DigestLogin",
      data: requestData,
    });
    return response.data;
  } catch (error) {
    console.error("DigestLogin failed:", error);
    throw error;
  }
};

export const verifyToken = async (
  securityToken: string,
  downloadImage: boolean
): Promise<VerifyTokenResponse> => {
  const requestData: VerifyTokenRequest = {
    SecurityToken: securityToken,
    DownloadImage: downloadImage,
  };

  try {
    const response: AxiosResponse<VerifyTokenResponse> = await apiClient({
      method: "post",
      url: "/Authentication/VerifyToken",
      data: requestData,
    });
    return response.data;
  } catch (error) {
    console.error("Login failed:", error);
    throw error;
  }
};

export const logout = async (
  securityToken: string
): Promise<LogoutResponse> => {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;
  const redirectUrl = `${baseUrl}/TSID_Redirect`;

  const requestData: LogoutRequest = {
    SecurityToken: securityToken,
    TSID_RedirectUrl: redirectUrl,
  };

  try {
    const response: AxiosResponse<LogoutResponse> = await apiClient({
      method: "post",
      url: "/Authentication/Logout",
      data: requestData,
    });
    return response.data;
  } catch (error) {
    console.error("Logout failed:", error);
    throw error;
  }
};

export const SSODisassocia = async (
  securityToken: string
): Promise<AuthResponse> => {
  const requestData: DisassociaTSIDRequest = {
    CmsSecurityToken: securityToken,
  };

  try {
    const response: AxiosResponse<AuthResponse> = await apiClient({
      method: "post",
      url: "/TeamsystemId/SSODisassocia",
      data: requestData,
    });
    return response.data;
  } catch (error) {
    console.error("Dissocia TSID failed:", error);
    throw error;
  }
};

export const sendPasswordRecovery = async (
  eMail: string
): Promise<RecoverPasswordResponse> => {
  const baseUrl = `${window.location.protocol}//${window.location.host}`;

  const requestData: RecoverPasswordRequest = {
    EMail: eMail,
    BaseUrl: baseUrl,
  };

  try {
    const response: AxiosResponse<RecoverPasswordResponse> = await apiClient({
      method: "post",
      url: "/RecoverPassword/RecoverPassword",
      data: requestData,
    });
    return response.data;
  } catch (error) {
    console.error("sendPasswordRecovery failed:", error);
    throw error;
  }
};

export const recoveryPasswordCheck = async (
  userName: string,
  digest: string
): Promise<RecoverPasswordCheckResponse> => {
  const requestData: RecoverPasswordCheckRequest = {
    UserName: userName,
    Digest: digest,
  };

  try {
    const response: AxiosResponse<RecoverPasswordCheckResponse> =
      await apiClient({
        method: "post",
        url: "/RecoverPassword/RecoverPasswordCheck",
        data: requestData,
      });
    return response.data;
  } catch (error) {
    console.error("recoveryPasswordCheck failed:", error);
    throw error;
  }
};
